//Models
PJQ.models.dailyReports.DailyReport = PJQ.models.BaseModel.extend({
	idAttribute: 'dailyReportId',
	endpoint: function () {
		if (this.get('dailyReportId')) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'dailyReports',
					value: this.get('dailyReportId')
				}
			]);
		}
		else {
			if (typeof this.get('reportDate') == null) {
				this.set('reportDate', new Date());
			}
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'dailyReports'
				}
			], [
				{
					parameter: 'reportDate',
					value: PJQ.helpers.dateHelpers.getDateString(this.get('reportDate'), 'yyyy-MM-dd')
				}
			]);
		}
	},
	parse: function (model) {
		model = model ? model : {};

		if (model.weather != null && model.weather.weatherId > 0) {
			this.weather = new PJQ.models.weather.WeatherDay(model.weather);
		}

		if (typeof model.reportDate === 'string') {
			model.reportDate = PJQ.helpers.dateHelpers.parseDateString(model.reportDate, false);
		}
		this.workLogs = new PJQ.collections.dailyReports.WorkLogs(model.workLogs);
		this.notes = new PJQ.collections.dailyReports.Notes(model.notes);
		this.expenses = new PJQ.collections.dailyReports.Expenses(model.expenses);
		this.deliveries = new PJQ.collections.dailyReports.Deliveries(model.deliveries);
		this.communicationLogs = new PJQ.collections.dailyReports.CommunicationLogs(model.communicationLogs);
		this.inspectionLogs = new PJQ.collections.dailyReports.InspectionLogs(model.inspectionLogs);
		this.surveyItems = new PJQ.collections.dailyReports.SurveyItems(model.surveyItems);
		this.attachments = new PJQ.collections.dailyReports.Attachments(_.sortBy(model.attachments, function (attachment) {
			return -attachment.attachmentId;
		}));

		return model;
	},
	getStatusColor: function () {
		let color = '#9E9E9E';
		switch (this.get('status')) {
			case 0:
				color = '#9E9E9E';
				break;
			case 1:
				color = '#4CAF50';
				break;
			case 2:
				color = '#2196F3';
				break;
			case 3:
				color = "#bd2130";
				break;
		}
		return color;
	},
	getStatusName: function () {
		let name;
		switch (this.get('status')) {
			case 0:
				name = 'Not Submitted';
				break;
			case 1:
				name = 'Submitted';
				break;
			case 2:
				name = 'Day Off';
				break;
			case 3:
				name = "Missed";
				break;
		}
		return name;
	},
	exportReport: function (mode, isDownload, settings, callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/export/link' + (_.size(mode) > 0 ? ('?mode=' + mode) : ''),
			data: settings,
			isApi2: true
		}).post().done(_.bind(function (response) {
			if (isDownload) {
				PJQ.files.handleDownload(response);
			}
			callback(response.url);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	},
	updateDelay: function (callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/delay',
			isApi2: true,
			data: this.toJSON()
		}).put().done(_.bind(function (response) {
			callback(response);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	},
	submit: function (signature, callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/submit',
			isApi2: true,
			data: {
				signature: signature
			}
		}).put().done(_.bind(function (response) {
			this.set('status', response.status);
			callback(response);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	},
	share: function (data, callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/share',
			data: {
				subject: data != null ? data.subject : null,
				emails: data != null ? data.emails : null,
			}
		}).post().done(_.bind(function (response) {
			callback(response.url);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	}
});

//Collections
PJQ.collections.dailyReports.DailyReports = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.DailyReport,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'dailyReports'
			}
		], [
			{
				parameter: 'startDate',
				value: PJQ.helpers.dateHelpers.getDateString(this.options.startDate, 'yyyy-MM-dd')
			},
			{
				parameter: 'endDate',
				value: PJQ.helpers.dateHelpers.getDateString(this.options.endDate, 'yyyy-MM-dd')
			}
		]);
	}
});